export const PopoverV2TriggerOn = {
    click: 'click',
    mouseover: 'mouseover',
};
